module.exports = __webpack_public_path__ + "static/img/top-img.0d3fd5fb.png";